// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__3Vstt","emptyMessage":"styles_emptyMessage__1wslt"};